import Action from 'actions';
import {getRepeatedAtLeastNTimes, getUnique} from 'helpers/array-helper';

class LineupAnalyzer {
    private players;
    constructor(private simplexLineup) {
        const {
            playersData: {players},
        } = Action.getState();

        this.players = players;
    }
    public getTeamNamesWithAtLeastNPlayers(atLeastPlayersQuantity: number): string[] {
        const teams = [];
        const playerIds = this.simplexLineup.getPlayerIds();
        playerIds.map((playerId) => {
            const player = this.players.getPlayer(playerId);
            // @ts-ignore
            this.canPlayerBeConsidered(player) && teams.push(player.team);
        });

        const repeatedTeamNames = getRepeatedAtLeastNTimes(teams, atLeastPlayersQuantity);

        return getUnique(repeatedTeamNames);
    }
    protected canPlayerBeConsidered(player): boolean {
        return !isEmpty(player);
    }
}

export {LineupAnalyzer};
